import { Loader2 } from 'lucide-react'

export function PageLoader() {
  return (
    <div className="flex items-center justify-center" style={{ minHeight: '300px' }}>
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  )
}
